import { useContext } from "react";
import { NotificationContextAPI } from "../context/NotificationContext";

const useNotification = () => {
  const context = useContext(NotificationContextAPI);
  return context
};

export default useNotification;
